import React from 'react';
import './Header.css';
import CTA from './CTA';
import ME1 from '../../assets/me.png';
import ME2 from '../../assets/me_2.png';
import ME3 from '../../assets/me_3.png';
import ME4 from '../../assets/me_4.png';
import HeaderSocials from './HeaderSocials';

const Header = () => {
    return (
        <header>
            <div className='container header__container'>
                <h4>Hello, I'm</h4>
                <div className='wrapper'>
                    <div className='typing-effect'>Dmitry Sinyavskiy</div>
                </div>
                <h3 className='text-light'>FullStack Developer</h3>
                <CTA />
                <HeaderSocials />
                <div className='me'>
                    <img src={ME2} alt='me' />
                </div>

                <a href='#contact' className='sroll__down'>
                    Scroll Down
                </a>
            </div>
        </header>
    );
};

export default Header;
